import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'ral-listado-polizas-mutua',
  templateUrl: './listado-polizas-mutua.component.html',
  styleUrls: ['./listado-polizas-mutua.component.scss']
})
export class ListadoPolizasMutuaComponent {
  displayedColumns: string[] = ["idPoliza", "producto", "titular", "matricula", "marca", "modelo"];
  dataSource = new MatTableDataSource<any>();

  constructor(
    public dialogRef: MatDialogRef<ListadoPolizasMutuaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { polizas: any[] }
  ) {
    this.dataSource.data = data.polizas;
  }

  seleccionar(poliza: any) {
    this.dialogRef.close(poliza); // devolvemos la póliza seleccionada
  }

  onClose() {
    this.dialogRef.close();
  }
}
